/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import "../../css/instruction.css";
import Swal from "sweetalert2";
import callApi from "../../utils/apiCaller";

import "../../css/instruction.css";
import {
  Banner,
  Button,
  ButtonGroup,
  Badge,
  Card,
  TextField,
  Modal,
  Tooltip,
  Layout,
  Link,
} from "@shopify/polaris";

import { Row, Col } from "reactstrap";

import { connect } from "react-redux";
import {
  actFetchShowLoadingPage,
  actFetchListPayPalAccounts,
} from "../../actions/index";
import Video from "./Video";
import config from "../../config/config";
import UserTour from "../UserTour";
import NotifyBuyer from "../Settings/NotifyBuyer";
import LogoIcon from "./LogoIcon";
import Step from "../Instructions/Step";

class PaypalSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoadingPage: false,
      loading: false,
      modalStatus: false,
      modalTitle: "New Paypal Account",
      modalType: "add",
      listPayPalAccounts: [],
      mainAccount: {},
      copyUsername: false,
      valueClentId: "",
      valueSecret: "",
      valueEmail: "",
      errClientId: "",
      errSecret: "",
      errEmail: "",
      idDelete: 0,
      idEdit: 0,
      plan: this.props.dataSettings.plan,
    };
  }

  closeModal = () => {
    this.setState({ modalStatus: false });
  };

  handleChangeClentId = (value) => {
    this.setState({ valueClentId: value });
    if (value !== "") {
      this.setState({ errClientId: "" });
    }
  };

  handleChangeSecret = (value) => {
    this.setState({ valueSecret: value });
    if (value !== "") {
      this.setState({ errSecret: "" });
    }
  };

  handleChangeEmail = (value) => {
    this.setState({ valueEmail: value });
    if (value !== "") {
      this.setState({ errEmail: "" });
    }
  };

  confirmDeleteAccount = (id) => {
    this.setState({ idDelete: id });
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This Paypal account will be permanently removed from our system until you add it again",
      showCancelButton: true,
      showConfirmButton: true,
    }).then((result) => {
      if (result.value) {
        this.detelePaypalAccount();
      }
    });
  };

  openModalEdit = (index) => {
    this.setState({ idEdit: this.props.listPayPalAccounts[index].id });
    this.setState({ modalType: "edit" });
    this.setState({ valueEmail: this.props.listPayPalAccounts[index].email });
    this.setState({
      valueClentId: this.props.listPayPalAccounts[index].client_id,
    });
    this.setState({
      valueSecret: this.props.listPayPalAccounts[index].secret,
    });
    this.setState({
      errEmail: "",
      errSecret: "",
      errClientId: "",
    });
    this.setState({ modalStatus: true });
  };

  setPrimaryAccount = async (index) => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "setPrimaryAccount",
      id: this.props.listPayPalAccounts[index].id,
    };
    callApi("get", params).then(async (res) => {
      this.props.fetchShowLoadingPage(false);
      let newListAccount = [...this.props.listPayPalAccounts];
      for (let i = 0; i < newListAccount.length; i++) {
        if (i !== index) {
          newListAccount[i].primary_account = "0";
        } else {
          newListAccount[i].primary_account = "1";
        }
      }

      this.props.fetchListPayPalAccounts(newListAccount);
      this.setState({ listPayPalAccounts: newListAccount });

      Swal.fire({
        icon: "success",
        title: "Successfully",
        text:
          res.data.dataPaypalAccount[0].email +
          " has been marked as the primary account",
        showCloseButton: false,
        showConfirmButton: false,
        timer: 3000,
      });
    });
  };

  detelePaypalAccount = async () => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "detelePaypalAccount",
      id: this.state.idDelete,
    };
    callApi("get", params).then(async (res) => {
      this.props.fetchShowLoadingPage(false);

      let index = this.state.listPayPalAccounts.findIndex(
        (x) => x.id === this.state.idDelete
      );
      let newListAccount = [...this.props.listPayPalAccounts];
      newListAccount.splice(index, 1);
      this.setState({ listPayPalAccounts: newListAccount });
      this.props.fetchListPayPalAccounts(newListAccount);

      Swal.fire({
        icon: "success",
        title: "Deleted successfully!",
        text: "",
        showCloseButton: false,
        showConfirmButton: false,
        timer: 3000,
      });
    });
  };

  childResponse = (err, res) => {
    console.log(res);
  };

  connectToPayPal = async () => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "connectToPayPal",
    };
    if (config.checkLocalStorage) {
      if (
        localStorage.getItem(config.shop + "-click-connect-account-paypal") !==
        null
      ) {
        let currentClick = localStorage.getItem(
          config.shop + "-click-connect-account-paypal"
        );
        localStorage.setItem(
          config.shop + "-click-connect-account-paypal",
          parseInt(currentClick) + 1
        );
      } else {
        localStorage.setItem(config.shop + "-click-connect-account-paypal", 1);
      }
      if (
        localStorage.getItem(config.shop + "-click-connect-account-paypal") >= 3
      ) {
        setTimeout(() => {
          let params = {
            action: "getDataPaypayAccount",
          };
          callApi("get", params).then(async (res) => {
            if (res.data.dataPaypalAccount.length === 0) {
              window.$crisp.push([
                "set",
                "session:event",
                ["synctrack-add-account-error"],
              ]);
            }
          });
        }, 10000);
      }
    }
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        this.props.fetchShowLoadingPage(false);
        // window.top.location.href = res.data.url;
        window.open(res.data.url, "connect paypal", "width=500,height=500");
      }
    });
  };

  componentDidMount = () => {
    window.onmessage = function (e) {
      if (e.data.type === "paypalConnected") {
        let params = {
          action: "processCodePayPalReturn",
          code: e.data.code,
        };
        callApi("get", params).then(async (res) => {
          if (res.data.state === 1) {
            window.location.reload();
          }
        });
      }
    };
  };

  processCodePayPalReturn = async (code) => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "connectToPayPal",
    };
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        this.props.fetchShowLoadingPage(false);
        // window.top.location.href = res.data.url;
        window.open(res.data.url, "connect paypal", "width=500,height=500");
      }
    });
  };

  savePaypalAccount = async () => {
    let id = 0;
    if (this.state.modalType === "edit") {
      id = this.state.idEdit;
    }
    if (validEmail(this.state.valueEmail) === false) {
      this.setState({ errEmail: "Account id is invalid!" });
    } else if (this.state.valueClentId === "") {
      this.setState({ errClientId: "Client ID is required" });
    } else if (this.state.valueSecret === "") {
      this.setState({ errSecret: "Client ID is required" });
    } else {
      this.props.fetchShowLoadingPage(true);
      let formData = new FormData();
      formData.append("email", this.state.valueEmail);
      formData.append("client_id", this.state.valueClentId);
      formData.append("secret", this.state.valueSecret);
      formData.append("id", id);
      formData.append("action", "savePaypalAccount");
      callApi("post", formData).then((res) => {
        this.props.fetchShowLoadingPage(false);
        if (res.data.state === 1) {
          this.props.fetchListPayPalAccounts(res.data.dataPaypalAccount);
          this.setState({
            listPayPalAccounts: res.data.dataPaypalAccount,
            modalStatus: false,
          });
          Swal.fire({
            icon: "success",
            title: "Successfully!",
            text: res.data.msg,
            showCloseButton: false,
            showConfirmButton: false,
            timer: 5000,
          });
        } else if (res.data.state === 0) {
          this.setState({ errClientId: res.data.msg });
          this.setState({ errSecret: res.data.msg });
        } else if (res.data.state === 2) {
          this.setState({ errEmail: res.data.msg });
        }
      });
    }
  };

  getAccountStatus = (confirm_status, payer_id) => {
    if (confirm_status === "1") {
      return (
        <Badge
          status={payer_id == null ? "critical" : "success"}
          progress="complete"
        >
          Confirmed
        </Badge>
      );
    } else if (confirm_status === "-1") {
      return (
        <Badge status="warning" progress="complete">
          Invalid Paypal Account
        </Badge>
      );
    }
  };

  addPaypalAccount = () => {
    if (
      (this.props.listPayPalAccounts.length === 1 &&
        this.props.dataSettings.plan === "free") ||
      (this.props.listPayPalAccounts.length === 1 &&
        this.props.dataSettings.plan === "basic")
    ) {
      Swal.fire({
        icon: "warning",
        title: "Note",
        text: "This function is only applicable for Plan Pro and above. Please upgrade your Plan to use it",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {});
    } else {
      if (
        this.props.listPayPalAccounts.length === 1 &&
        this.props.listPayPalAccounts[0].email == null
      ) {
        Swal.fire({
          icon: "warning",
          title: "Note",
          text: "To use multiple accounts we need you to update the Email for an account that was previously added",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            this.setState({ idEdit: this.props.listPayPalAccounts[0].id });
            this.setState({ modalType: "edit" });
            this.setState({
              valueEmail: "",
              errEmail: "",
              errSecret: "",
              errClientId: "",
            });
            this.setState({
              valueClentId: this.props.listPayPalAccounts[0].client_id,
            });
            this.setState({
              valueSecret: this.props.listPayPalAccounts[0].secret,
            });
            this.setState({ modalStatus: true });
          }
        });
      } else {
        this.setState({ modalType: "add" });
        this.setState({ valueEmail: "" });
        this.setState({
          valueClentId: "",
        });
        this.setState({
          valueSecret: "",
        });
        this.setState({
          errEmail: "",
          errSecret: "",
          errClientId: "",
        });
        this.setState({ modalStatus: true });
      }
    }
  };

  render() {
    const { listPayPalAccounts } = this.props;
    return (
      <div className="app_instructions_page">
        <div>
          <Row>
            <Col xs="12" lg="12" sm="12" xl="8">
              <Row>
                <Card title="Connecting App with Paypal" sectioned>
                  {listPayPalAccounts.length === 0 ? (
                    <Banner
                      title="You are not connected to your PayPal account."
                      status="warning"
                    >
                      In order to make the app work properly, please click
                      "Connect With PayPal" below.{" "}
                      <Link
                        external
                        url="https://www.youtube.com/watch?v=939S7HqgJi4&feature=emb_title"
                      >
                        (How to get it?)
                      </Link>
                      <br />
                      <br />
                      <b>
                        Note: Disable pop-up blocking on your browser so that
                        the connecting pop-up can appear or try with incognito
                        browser
                      </b>
                    </Banner>
                  ) : (
                    <div className="pl-2">
                      <p style={{ fontSize: "16px" }}>
                        Once Paypal account is connected, our app will auto-sync
                        the tracking number of fulfilled/completed orders to
                        your Paypal account
                      </p>
                      {listPayPalAccounts.map(function (value, index) {
                        return (
                          <div
                            key={index + 1}
                            className="mt-4 pl-4 pr-4 pt-3 pb-3 paypal-account-layout"
                            style={{
                              fontSize: "16px",
                              lineHeight: "34px",
                            }}
                          >
                            {config.role !== "view" ? (
                              <div className="group-action">
                                <ButtonGroup>
                                  {value.primary_account !== "1" ? (
                                    <div className="other-button">
                                      <Tooltip content="Mark as primary Account">
                                        <Button
                                          onClick={() =>
                                            this.setPrimaryAccount(index)
                                          }
                                        >
                                          <i className="fas fa-star"></i>
                                        </Button>
                                      </Tooltip>
                                    </div>
                                  ) : null}
                                  {value.payer_id === null ? (
                                    <div className="other-button">
                                      <Tooltip content="Edit Account">
                                        <Button
                                          onClick={() =>
                                            this.openModalEdit(index)
                                          }
                                        >
                                          <i className="fas fa-edit" />
                                        </Button>
                                      </Tooltip>
                                    </div>
                                  ) : null}
                                  <div className="delete-button">
                                    <Tooltip content="Delete Account">
                                      <Button
                                        className=""
                                        onClick={() =>
                                          this.confirmDeleteAccount(value.id)
                                        }
                                      >
                                        <i className="far fa-trash-alt" />
                                      </Button>
                                    </Tooltip>
                                  </div>
                                </ButtonGroup>
                              </div>
                            ) : null}
                            {value.primary_account === "1" ? (
                              <div>
                                <Badge status="success">
                                  <strong>Primary Account</strong>
                                </Badge>
                                {this.getAccountStatus(
                                  value.confirm_status,
                                  value.payer_id
                                )}
                                <br />
                              </div>
                            ) : (
                              <div>
                                <Badge>
                                  <strong>Second account</strong>
                                </Badge>
                                {this.getAccountStatus(
                                  value.confirm_status,
                                  value.payer_id
                                )}
                                <br />
                              </div>
                            )}
                            {value.email !== null && value.email !== "" ? (
                              <div>
                                <strong>Account: </strong> {value.email}
                                <br />
                              </div>
                            ) : null}
                            <strong>
                              {value.payer_id === null
                                ? "Client Id: "
                                : "PayPal Merchant ID: "}
                            </strong>{" "}
                            {value.payer_id === null
                              ? value.client_id_show
                              : value.payer_id}
                          </div>
                        );
                      }, this)}
                    </div>
                  )}
                  {config.role !== "view" ? (
                    <div className="mt-4 ml-2">
                      <div className="d-flex">
                        <button
                          className="connect-to-paypal ml-2"
                          onClick={this.connectToPayPal}
                        >
                          <LogoIcon />
                          <b>
                            {this.props.listPayPalAccounts.length === 0
                              ? "Connect via PayPal login"
                              : "Add PayPal account"}
                          </b>
                        </button>
                        {config.platform === "WOO_COMMERCE" ? (
                          <button
                            className="connect-to-paypal ml-2"
                            onClick={() => this.setState({ modalStatus: true })}
                          >
                            <LogoIcon />
                            <b>
                              {this.props.listPayPalAccounts.length === 0
                                ? "Connect PayPal manually"
                                : "Add account manually"}
                            </b>
                          </button>
                        ) : null}
                      </div>
                      {this.props.listPayPalAccounts.length === 1 ? (
                        <div className="mt-5">
                          <Banner
                            title="Note: Do you regularly change your PayPal account to reduce the spike on one account?"
                            status="info"
                          >
                            <p>
                              Please connect to the respective PayPal accounts
                              in the application so that tracking information is
                              uploaded to the correct PayPal account
                            </p>
                          </Banner>
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  <Modal
                    open={this.state.modalStatus}
                    onClose={this.closeModal}
                    title={
                      this.state.modalType === "add"
                        ? "Add new account"
                        : "Edit Account"
                    }
                    primaryAction={{
                      content: "Save",
                      onAction: this.savePaypalAccount,
                    }}
                    secondaryActions={[
                      {
                        content: "Cancel",
                        onAction: this.closeModal,
                      },
                    ]}
                  >
                    <Modal.Section>
                      <TextField
                        label="Account Email*:"
                        value={this.state.valueEmail}
                        onChange={this.handleChangeEmail}
                        error={this.state.errEmail}
                        type="email"
                      />
                      <TextField
                        label="Client ID*:"
                        value={this.state.valueClentId}
                        onChange={this.handleChangeClentId}
                        error={this.state.errClientId}
                      />
                      <TextField
                        label="Secret* :"
                        type="password"
                        value={this.state.valueSecret}
                        onChange={this.handleChangeSecret}
                        error={this.state.errSecret}
                      />
                      <Step />
                    </Modal.Section>
                  </Modal>
                  <UserTour connectPayPal={this.connectToPayPal} />
                </Card>
              </Row>
              <Row className="mt-3">
                <Card sectioned title="Notify Buyer">
                  <NotifyBuyer />
                </Card>
              </Row>
            </Col>
            <Video />
          </Row>
        </div>
      </div>
    );
  }
}

function validEmail(email) {
  // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var re =
    /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const mapStateToProps = (state) => {
  return {
    listPayPalAccounts: state.listPayPalAccounts,
    dataSettings: state.dataSettings,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchShowLoadingPage: (showLoadingPage) => {
      dispatch(actFetchShowLoadingPage(showLoadingPage));
    },
    fetchListPayPalAccounts: (dataPaypalAccount) => {
      dispatch(actFetchListPayPalAccounts(dataPaypalAccount));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaypalSettings);
